import { defineStore } from 'pinia';

export const appStore = defineStore('app', {
  // other options...
  state: () => {
    return {
      device: 'desktop', // 当前设备值
      sidebar: false, // 侧边栏 true or false
      layout: 'sidemenu', // 侧边栏布局 sidemenu or topmenu
      theme: 'light', // nav菜单主题 light or dark
      contentWidth: 'Fixed', // 内容布局 Fixed or Fluid
      fixSidebar: false, // 固定左侧菜单栏 true or false
      fixHeader: false, // 固定Header true or false
      multiTab: false, // tabs标签 true or fasle
    };
  },
});